<div class="confirm-dialog">
  <div class="confirm-dialog__header">
    <pdq-heading element="h5">Proceed with Custom Template?</pdq-heading>
    <pdq-button variant="ghost" plain="true" icon="close" size="small" (onClick)="cancel()"></pdq-button>
  </div>
  <pdq-divider></pdq-divider>

  <div class="confirm-dialog__body">
    <p class="confirm-dialog__text">Read this before you confirm.</p>
    <p class="confirm-dialog__text">By enabling a custom template:</p>
    <ul class="confirm-dialog__list">
      <li>You lose the drag and drop editor.</li>
      <li>You own the code. Be careful of what you change.</li>
      <li>
        You lose the upsell surface entirely. Only Cart Items and Discount Codes can go in a custom template. Goals
        Progress Bar, Top Bar, Announcement Bar, Cart Subtotal, Checkout Area, Digital Upsell and Upsell Items can't be
        shown at all.
      </li>
    </ul>
    <p class="confirm-dialog__text">
      If you decide to use a custom template, you will need to check back regularly for updates to ensure your code is
      compatible with the latest version of the Smart Cart. We cannot guarantee that your custom template will work with
      future versions of the Smart Cart
    </p>
  </div>

  <pdq-divider></pdq-divider>
  <div class="confirm-dialog__footer">
    <pdq-button variant="secondary" (onClick)="cancel()">Cancel</pdq-button>
    <pdq-button variant="primary" (onClick)="confirm()">I understand, Save &amp; Continue</pdq-button>
  </div>
</div>
